export default {
  dynamics: '{{change}} vs previous {{time_unit}}',
};
